"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const constants_1 = require("configs/routes/constants");
const translationContext_1 = require("configs/translationContext");
const ClassTabButton = ({ variation = 'primary', className, onClick }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { position: tooltip_1.default.TOOLTIP_POSITION.BOTTOM, content: t('module_editor.manage_classes_tooltip', {
            checkOnlineEvent: true
        }), children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: constants_1.ROUTES.CLASS.LIST, className: (0, classnames_1.default)(`hot-button hot-button--${variation} _text-decoration-none`, className), target: "_blank", rel: "noopener noreferrer", onClick: onClick, children: [t('module_editor.manage_classes', { checkOnlineEvent: true }), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'arrow-up-right'], className: "_ml-2 _text-3" })] }) }));
};
exports.default = ClassTabButton;
